import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import heroBg from "../assets/images/hero-bg.JPG";
import {
  Phone,
  MessageCircle,
  Wifi,
  ArrowUpDown,
  Snowflake,
  Car,
  Sofa,
  Zap,
  Clock,
  Shield,
  Flame,
  Coffee,
  Camera,
  Building2,
  Tv,
  Refrigerator
} from "lucide-react";

const features = [
  { icon: Wifi, title: "Free Wi-Fi" },
  { icon: ArrowUpDown, title: "Lift Access" },
  { icon: Snowflake, title: "Air-Conditioned Rooms" },
  { icon: Car, title: "Car Parking" },
  { icon: Sofa, title: "Fully Furnished Rooms" },
  { icon: Zap, title: "24/7 Power Backup" },
  { icon: Clock, title: "24/7 Guest Support" },
  { icon: Coffee, title: "Electric Kettle" },
  { icon: Flame, title: "24/7 Hot Water" },
  { icon: Shield, title: "Security Service" },
  { icon: Camera, title: "CCTV Surveillance" },
  { icon: Building2, title: "Private Balcony with Scenic Views" },
  { icon: Tv, title: "Television" },
  { icon: Refrigerator, title: "Refrigerator" },
];

export default function HomePage() {

  const handleCall = () => {
    window.open("tel:+919187501932");
  };

  const handleWhatsApp = () => {
    window.open(
      "https://wa.me/919187501932?text=Hello, I'm interested in Ananya Residency"
    );
  };

  return (
    <div className="min-h-screen">

      {/* HERO SECTION */}
      <section className="relative h-[600px] flex items-center justify-center overflow-hidden">

        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              `url('${heroBg}')`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 to-black/40"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 text-center text-white">

          <h1 className="text-5xl md:text-6xl font-serif font-bold mb-4">
            Ananya Residency
          </h1>

          <p className="text-xl md:text-2xl mb-2 font-light">
            Service Apartment in Manipal
          </p>

          <p className="text-lg mb-6 text-gray-200">
            Comfortable Stay for Students, Parents, Hospital Visitors & Tourists
          </p>

          <p className="mb-8 text-gray-200">
            Vidyarathna Nagar, V.S Acharya Road, Manipal, Udupi
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">

            <Button
              size="lg"
              onClick={handleCall}
              className="bg-[#8B6F47] hover:bg-[#6D5838] text-white text-lg px-8 py-6"
            >
              <Phone className="w-5 h-5 mr-2" />
              Call Now
            </Button>

            <Button
              size="lg"
              onClick={handleWhatsApp}
              variant="outline"
              className="bg-white/10 backdrop-blur-sm text-white border-2 border-white hover:bg-white hover:text-[#8B6F47] text-lg px-8 py-6"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp Us
            </Button>

          </div>

        </div>
      </section>


      {/* ABOUT SECTION */}
      <section className="py-20 bg-white">

        <div className="container mx-auto px-4">

          <div className="max-w-4xl mx-auto text-center">

            <h2 className="text-4xl font-serif font-bold text-[#8B6F47] mb-6">
              Welcome to Ananya Residency
            </h2>

            <div className="space-y-4 text-lg text-gray-700">

              <p>
                Ananya Residency offers clean, comfortable and affordable service apartment in Manipal.
              </p>

              <p>
                Ideal for students, parents visiting Manipal, hospital visitors and tourists.
              </p>

              <p>
                All rooms include attached bathrooms, balcony, and essential modern amenities for a peaceful stay.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* AMENITIES SECTION */}
      <section className="py-16 bg-gradient-to-b from-[#FFF8DC] to-white">

        <div className="container mx-auto px-4">

          <h2 className="text-3xl font-serif font-bold text-center text-[#8B6F47] mb-10">
            Amenities & Facilities
          </h2>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">

            {features.map((feature, index) => (

              <div
                key={index}
                className="group bg-white border border-[#E6D5C3] rounded-xl p-4 text-center hover:border-[#8B6F47] hover:shadow-md transition-all duration-300"
              >

                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-[#FFF8DC] mb-2 group-hover:bg-[#8B6F47] transition">

                  <feature.icon className="w-5 h-5 text-[#8B6F47] group-hover:text-white" />

                </div>

                <p className="text-sm font-medium text-[#6B5637]">
                  {feature.title}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>


      {/* CTA SECTION */}
      <section className="py-16 bg-[#8B6F47] text-white">

        <div className="container mx-auto px-4 text-center">

          <h2 className="text-3xl font-serif font-bold mb-4">
            Ready to Book Your Stay?
          </h2>

          <p className="text-lg mb-8 text-gray-200">
            Contact us today for availability and best rates
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">

            <Button
              size="lg"
              onClick={handleCall}
              className="bg-white text-[#8B6F47] hover:bg-gray-100 text-lg px-8 py-6"
            >
              <Phone className="w-5 h-5 mr-2" />
              Call +91 91875 01932
            </Button>

            <Button
              size="lg"
              onClick={handleWhatsApp}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#8B6F47] text-lg px-8 py-6"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp Us
            </Button>

          </div>

        </div>

      </section>


    </div>
  );
}
